// Module-level memoization for REFERENCE data (settings, categories, file
// types, agents, domains — things that change rarely). Dedupes concurrent
// calls (all callers share one in-flight promise) and reuses resolved
// results for the session. The owning module MUST call `clear()` from its
// own mutations so edits are visible immediately.
//
// Do NOT use this for mutable list data (contacts, properties, files,
// journals, comments, reminders).
export const createReferenceMemo = () => {
  const cache = new Map();
  return {
    run(key, fetcher) {
      if (cache.has(key)) return cache.get(key);
      const promise = Promise.resolve()
        .then(fetcher)
        .catch((err) => {
          cache.delete(key); // don't cache failures
          throw err;
        });
      cache.set(key, promise);
      return promise;
    },
    clear() {
      cache.clear();
    },
  };
};
